import React from 'react';
import PropTypes from 'prop-types';

const Button = ({
  children,
  onClick,
  containerClassname,
  buttonClassname,
}) => (
  <div className={containerClassname}>
    <button className={buttonClassname} onClick={onClick}>
      {children}
    </button>
  </div>
);

Button.propTypes = {
  buttonClassname: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  onClick: PropTypes.func,
  containerClassname: PropTypes.string,
};

export default Button;
